import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  deleteEarlyRegistrationStart,
  deleteEarlyRegistrationSuccess,
  deleteEarlyRegistrationFailed,
} from "../redux/deleteEarlyRegistration";
import { deleteEarlyRegistrationApi } from "core/http/service/timeKeeping";
import { earlyRegistrationDeleteId } from "../redux/selector";
import { toast } from "react-toastify";
import { ErrorMessage } from "core/http/service/decleareLeave/const";

function* deleteEarlyRegistrationWork(action) {
  const id = yield select(earlyRegistrationDeleteId);
  const { screenCode, callback } = action.payload;

  try {
    yield call(deleteEarlyRegistrationApi, screenCode, id);

    yield put({
      type: deleteEarlyRegistrationSuccess.type,
    });
    toast.success("Đơn của bạn đã được xóa thành công");

    callback?.();
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: deleteEarlyRegistrationFailed.type,
    });
  }
}

function* watchDeleteEarlyRegistration() {
  yield takeLatest(
    deleteEarlyRegistrationStart.type,
    deleteEarlyRegistrationWork
  );
}

export default function* deleteEarlyRegistrationSaga() {
  yield all([watchDeleteEarlyRegistration()]);
}
